type EventListener<T> = (event: T)=>void;

class EventHandler<T extends Event> {

	private waitList: EventListener<T>[] = [];
	private event: T|null = null;

	private get hasHappened(): boolean {
		return this.event !== null;
	}

	public callAfterItHappens(fn: EventListener<T>) {
		if (this.hasHappened) {
			fn(this.event!);
			return;
		}
		this.waitList.push(fn);
	}

	public itHappened(event: T): void
	{
		if (this.hasHappened) {
			return; // should never happen; ignore if happens
		}

		this.event = event;
		for(const fn of this.waitList) {
			fn(event);
		}
		this.waitList = [];
	}
}

const onDomLoadedHandler = new EventHandler<Event>();
export function afterDomIsReady(fn: EventListener<Event>): void {
	checkThatHasBeenInitialized();
	onDomLoadedHandler.callAfterItHappens(fn);
}

const onLoadHandler = new EventHandler<Event>();
export function afterEverythingHasBeenLoaded(fn: EventListener<Event>): void {
	checkThatHasBeenInitialized();
	onLoadHandler.callAfterItHappens(fn);
}

let initCalled = false;
const checkThatHasBeenInitialized = () => {
	if (!initCalled) {
		throw new Error('You have forgotten to call init().');
	}
};

/**
 * This MUST be called before load and DOMLoaded event happen
 */
export function init() {
	initCalled = true;
	if (document.readyState !== 'loading') {
		throw new Error('You have called init() too late, please call it earlier.')
	}

	window.addEventListener(
		'load',
		onLoadHandler.itHappened.bind(onLoadHandler)
	);
	document.addEventListener(
		'DOMContentLoaded',
		onDomLoadedHandler.itHappened.bind(onDomLoadedHandler)
	)
}
